import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e26638d0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container",
  ref: "containerRef"
};
const _hoisted_2 = {
  class: "headerStyle"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "TOP", -1));
import headerComp from '@/components/header/index.vue';
import footerComp from '@/components/footer/index.vue';
import loadPage from '@/components/loading/load.vue';
import { ElConfigProvider } from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { CaretTop } from '@element-plus/icons-vue';
import { useThrottleFn } from '@vueuse/core';

import { useRoute } from 'vue-router';
import { ref, computed, onMounted, onUnmounted, onDeactivated } from 'vue';
export default {
  __name: 'App',
  setup(__props) {
    const route = useRoute();
    const isScroll = ref(true);
    const showOverlay = ref(true);
    let isHeader = ref(true);
    const handleScroll = useThrottleFn(() => {
      if (window.scrollY > 100) {
        isHeader.value = false;
      } else {
        isHeader.value = true;
      }
    }, 50);

    //那些是需要显示透明头部的
    const headerList = ['home'];
    //是否显示透明头部
    const isShowTransparentHeader = computed(() => {
      return headerList.some(item => {
        return route.path.includes(item) && !route.path.includes('detail');
      });
    });
    onMounted(() => {
      window.onload = () => {
        showOverlay.value = false;
      };
      window.addEventListener('scroll', handleScroll);
    });

    // 移除监听事件
    onUnmounted(() => {
      window.onload = null;
    });
    onDeactivated(() => {
      window.removeEventListener('scroll', handleScroll);
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_backtop = _resolveComponent("el-backtop");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(showOverlay) ? (_openBlock(), _createBlock(loadPage, {
        key: 0
      })) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_2, [_ctx.$route.meta.isShowAppHeader ? (_openBlock(), _createBlock(headerComp, {
        key: 0,
        isScroll: _unref(isScroll)
      }, null, 8, ["isScroll"])) : _createCommentVNode("", true)], 512), [[_vShow, _unref(isShowTransparentHeader) && _unref(isHeader)]]), _withDirectives(_createElementVNode("div", null, [_ctx.$route.meta.isShowAppHeader ? (_openBlock(), _createBlock(headerComp, {
        key: 0,
        isScroll: !_unref(isScroll)
      }, null, 8, ["isScroll"])) : _createCommentVNode("", true)], 512), [[_vShow, !_unref(isShowTransparentHeader) || !_unref(isHeader)]]), _createVNode(_unref(ElConfigProvider), {
        locale: _unref(zhCn)
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      }, 8, ["locale"]), _createVNode(footerComp), _createVNode(_component_el_backtop, {
        right: 50,
        bottom: 30
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          size: 22,
          color: "#409eff"
        }, {
          default: _withCtx(() => [_createVNode(_unref(CaretTop))]),
          _: 1
        }), _hoisted_3]),
        _: 1
      })], 512);
    };
  }
};